import React, { Component } from 'react';
import { drawCircle, drawLine, clearCtx, fadeCtx } from './drawhelp';

import RangeComponent from './Components/RangeComponent';
import LineSettingsComponent from './Components/LineSettingsComponent';
import * as fourier from './fourier';
import PublishResult from './PublishResult';
import { FillInGaps, Normalize } from './HelpFunctions';

class DrawResult extends Component {
	constructor(props) {
		super(props);
		this.canvas = React.createRef();
		let stored_settings = {};
		try {
			stored_settings = JSON.parse(localStorage.getItem('settings'));
		} catch {

		}

		this.state = {
			running: false,
			s: {
				speed: 20,

				circles_show: true,
				circles_pixels: 1,
				circles_color: "#cccccc",

				arrows_show: true,
				arrows_pixels: 1,
				arrows_color: "#888888",

				origin_show: true,
				origin_pixels: 3,
				origin_color: "#ccccff",

				path_pixels: 5,
				path_color: "#8888ff",
				path_show: true,

				...stored_settings,

				number_of_circles: 7,
				zoom_to_circle: 1
			}
		}
		this.current_time = 0;

		this.sample_step = 0.005;
		this.circles = [];
		this.max_circles = 800;
		this.zoomfactor = 1;

		this.step_size = 0.005;
		this.trace_path = [];

		this.zoom = {
			x: 0,
			y: 0,
			ratio: 1
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
		this.stop();
	}

	componentDidMount() {
		this._isMounted = true;

		this.ctx = this.canvas.current.getContext("2d");
		this.origin_canvas = document.createElement('canvas');
		this.trace_canvas = document.createElement('canvas');
		this.circle_canvas = document.createElement('canvas');

		let width = this.canvas.current.width;
		let height = this.canvas.current.height;
		this.trace_canvas.width = width;
		this.trace_canvas.height = height;

		this.circle_canvas.width = width;
		this.circle_canvas.height = height;

		this.origin_canvas.width = width;
		this.origin_canvas.height = height;

		this.origin_ctx = this.origin_canvas.getContext("2d");
		this.trace_ctx = this.trace_canvas.getContext("2d");
		this.circle_ctx = this.circle_canvas.getContext("2d");

		this.points = FillInGaps(this.props.points);
		if (this.props.normalize_margin > 0)
			this.points = Normalize(this.points, this.props.normalize_margin);
		this.drawOrigin();

		this.start();
	}

	getRadiusForZoom(zoom_to_circle) {
		let arr = [];
		for (let pi = 0; pi < Math.PI * 2; pi += .1) {
			let x = 0;
			let y = 0;
			for (let i = zoom_to_circle; i < this.circles.length; i++) {
				[x, y] = fourier.getPointOnCircle(this.circles[i], pi, x, y);
			}
			arr.push(Math.sqrt(x * x + y * y));
		}
		let radius = Math.max(...arr);
		return radius;
	}

	setZoom(zoom_to_circle) {
		if (zoom_to_circle > this.circles.length)
			zoom_to_circle = this.circles.length;

		let circle = this.circles[zoom_to_circle - 1];
		this.zoom = {
			...this.zoom,
			x: circle.center_x,
			y: circle.center_y
		}
	}

	copyToScreen(ctx) {
		this.ctx.drawImage(ctx.canvas, 0, 0);
	}

	drawOrigin() {
		let x1 = undefined, y1;

		for (let time = 0; time < Math.PI * 2; time += this.sample_step) {
			let [x2, y2, ignore] = fourier.getOrigin(this.points, time);
			if (ignore) {
				x1 = undefined;
			} else if (x1 !== undefined) {
				drawLine(
					this.origin_ctx, x1, y1, x2, y2,
					{
						color: this.state.s.origin_color,
						width: this.state.s.origin_pixels
					},
					this.zoom);
			}
			[x1, y1] = [x2, y2];
		}

		// Draw a cross at origo
		drawLine(
			this.origin_ctx, 0, .9, 0, -.9,
			{ color: "#ddd" }, this.zoom);
		drawLine(
			this.origin_ctx, .9, 0, -.9, 0,
			{ color: "#ddd" }, this.zoom);
	}

	start() {
		setTimeout(() => this.interval(), 100);
		this.setState({
			running: true
		});
	}

	stop() {
		this.setState({
			running: false
		})
	}

	// Draw and step forward
	interval() {
		if (this._isMounted && this.state.running) {
			// Next step
			let time = this.current_time;
			if (this.state.running) {
				time += this.step_size * (this.state.s.speed / 20) * this.zoom.ratio;
				if (time > Math.PI * 2) {
					time -= Math.PI * 2;
				}
				if (Math.floor(time) !== Math.floor(time + this.step_size)) {
					fadeCtx(this.trace_ctx, .2, this.ctx);
				}
			}
			this.drawLayout(time, this.state.s.number_of_circles);

			this.current_time = time;
			setTimeout(() => this.interval(), 1);
		}
	}

	drawPath(time, number_of_circles) {
		// remove warning on line below
		// eslint-disable-next-line
		let [dummy1, dummy2, start] = fourier.getOrigin(this.points, time);

		// Draw trace
		let pos = {
			x: this.circles[number_of_circles - 1].x,
			y: this.circles[number_of_circles - 1].y,
			start: start,
			time: time
		};

		this.trace_path.unshift(pos);
		{
			let step = this.step_size * this.state.s.speed / 20;
			let trace_path_max = Math.ceil((Math.PI * 2) / step);
			this.trace_path = this.trace_path.slice(0, trace_path_max);
		}

		let last_pos;
		clearCtx(this.trace_ctx);
		for (let i = 0; i < this.trace_path.length; i++) {
			let pos = this.trace_path[i];
			let alpha = Math.ceil(255 - 255 * (i / (2 * this.trace_path.length))).toString(16).padStart(2, "0");
			if (last_pos) {
				drawLine(this.trace_ctx,
					pos.x, pos.y,
					last_pos.x, last_pos.y,
					{
						color: this.state.s.path_color + alpha,
						width: pos.start ? 1 : this.state.s.path_pixels
					},
					this.zoom);
			}
			last_pos = pos;
		}
	}

	drawLayout(time, number_of_circles) {
		while (this.circles.length < number_of_circles) {
			let circle = fourier.findBestCircle(this.circles, this.points, this.sample_step);
			this.circles.push(circle);
		}

		fourier.updateCirclePositions(this.circles, time);

		// Update where and how we zoom
		this.setZoom(this.state.s.zoom_to_circle)

		clearCtx(this.ctx);

		if (this.state.s.origin_show) {
			if (this.state.s.zoom_to_circle !== 0) {
				clearCtx(this.origin_ctx);
				this.drawOrigin();
			}
			this.copyToScreen(this.origin_ctx);
		}

		if (number_of_circles > 0) {
			this.drawPath(time, number_of_circles);
			if (this.state.s.path_show) {
				this.copyToScreen(this.trace_ctx);
			}

			clearCtx(this.circle_ctx);
			if (this.state.s.circles_show) {

				for (let i = 0; i < number_of_circles; i++) {
					if (this.state.s.zoom_to_circle - 1 <= i) {
						let circle = this.circles[i];
						drawCircle(
							this.circle_ctx,
							circle.center_x,
							circle.center_y,
							circle.radius,
							{
								color: this.state.s.circles_color,
								width: this.state.s.circles_pixels
							},
							this.zoom);
					}
				}
			}

			if (this.state.s.arrows_show) {
				for (let i = 0; i < number_of_circles; i++) {
					if (this.state.s.zoom_to_circle - 1 <= i) {
						let [x1, y1] = [this.circles[i].center_x, this.circles[i].center_y];
						let [x2, y2] = [this.circles[i].x, this.circles[i].y];
						drawLine(
							this.circle_ctx, x1, y1, x2, y2,
							{
								color: this.state.s.arrows_color,
								width: this.state.s.arrows_pixels
							},
							this.zoom);
					}
				}
			}
			this.copyToScreen(this.circle_ctx);
		}
	}

	settingchange(name, value) {
		console.log("settingchange", name, value);
		let new_settings = {
			...this.state.s,
			[name]: value
		};
		this.setState({ s: new_settings });
		localStorage.setItem('settings', JSON.stringify(new_settings));
		if (name === "zoom_to_circle") {
			let radius = this.getRadiusForZoom(value);
			this.zoom = { ratio: value === 1 ? 1 : radius };
			this.setZoom(value);
		}
		if (name === "number_of_circles") {
			if (value !== this.circles.length) {
				while (value > this.circles.length) {
					let circle = fourier.findBestCircle(this.circles, this.points, this.sample_step);
					this.circles.push(circle);
				}
				clearCtx(this.trace_ctx);

				for (let i = 0; i < this.trace_path.length; i++) {
					let pos = this.trace_path[i];
					fourier.updateCirclePositions(this.circles, pos.time);
					let last_circle = this.circles[value - 1];
					pos.x = last_circle.x;
					pos.y = last_circle.y;
				}
				fourier.updateCirclePositions(this.circles, this.current_time);
				this.drawPath(this.current_time, value);

				this.setState({
					s: {
						...this.state.s,
						[name]: value
					}
				});
			}
		}

		if (!this.state.running)
			this.drawLayout(this.current_time, this.circles.length);
	}


	render() {
		if (!this.props)
			return <></>;

		return (
			<div>
				<canvas
					ref={this.canvas}
					width={800}
					height={600}
					style={{ border: "1px solid black" }}
				/>
				<br />
				{
					this.state.running ?
						<button onClick={() => this.stop()}>Pause</button>
						:
						<button onClick={() => this.start()}>Continue</button>
				}
				<PublishResult
					points={this.points}
					circles={this.circles}
				/>
				<br />
				<RangeComponent
					value={this.state.s.number_of_circles}
					name="number_of_circles"
					text={"Number of vectors/circles: " + this.state.s.number_of_circles}
					max_add={Math.max(this.circles.length - this.state.s.number_of_circles, 10)}
					max={this.max_circles}
					min={1}
					callback={(n, v) => this.settingchange(n, v)}
				/>
				<RangeComponent
					value={this.state.s.zoom_to_circle}
					name="zoom_to_circle"
					text={"Zoom into circle: " + this.state.s.zoom_to_circle}
					max={this.state.s.number_of_circles === 0 ? 0 : this.state.s.number_of_circles - 1}
					min={1}
					callback={(n, v) => this.settingchange(n, v)}
				/>
				<RangeComponent
					value={this.state.s.speed}
					name="speed"
					text={"Speed/step size: " + this.state.s.speed}
					max={100}
					min={1}
					callback={(n, v) => this.settingchange(n, v)}
				/>
				<table>
					<tbody>
						<LineSettingsComponent
							values={{
								show: this.state.s.circles_show,
								color: this.state.s.circles_color,
								pixels: this.state.s.circles_pixels,
							}}
							name="circles"
							text="Circles"
							callback={(n, v) => this.settingchange(n, v)}
						/>
						<LineSettingsComponent
							values={{
								show: this.state.s.arrows_show,
								color: this.state.s.arrows_color,
								pixels: this.state.s.arrows_pixels,
							}}
							name="arrows"
							text="Vectors"
							callback={(n, v) => this.settingchange(n, v)}
						/>
						<LineSettingsComponent
							values={{
								show: this.state.s.path_show,
								color: this.state.s.path_color,
								pixels: this.state.s.path_pixels,
							}}
							name="path"
							text="Path"
							callback={(n, v) => this.settingchange(n, v)}
						/>
						<LineSettingsComponent
							values={{
								show: this.state.s.origin_show,
								color: this.state.s.origin_color,
								pixels: this.state.s.origin_pixels,
							}}
							name="origin"
							text="Origin"
							callback={(n, v) => this.settingchange(n, v)}
						/>
					</tbody>
				</table>
			</div >
		)
	}
}

export default DrawResult;